import React from 'react';
import { useUserProjectQuery } from '../../../Projects/operation.generated';
import { Project } from '../types';

const useProjectAccessAbility = ({
  projectId,
  projectAccess,
}: {
  projectId: string;
  projectAccess: Project['projectAccess'];
}) => {
  // cache-only otherwise unnecessary network calls
  const { data: userQuery } = useUserProjectQuery({
    variables: { inputs: { projectId } },
    fetchPolicy: 'cache-only',
    returnPartialData: true,
  });
  const projectPermissionsFromUserQuery =
    userQuery?.user?.project?.projectAccess?.viewerAccessRole?.permissions;
  const memoizeProjectAbility = React.useMemo(
    () =>
      projectPermissionsFromUserQuery ||
      projectAccess?.viewerAccessRole?.permissions,
    [projectAccess, projectPermissionsFromUserQuery]
  );

  return {
    projectAbility: memoizeProjectAbility,
  };
};

export default useProjectAccessAbility;
